<template>
  <div class="CartResumeAdditionalOptionCard">
    <div class="CartResumeAdditionalOptionCard-thumbnail">
      <img :data-src="additionalOption.thumbnail" alt="" class="lazyload" />
    </div>
    <div class="CartResumeAdditionalOptionCard-content">
      <p class="CartResumeAdditionalOptionCard-name">{{ additionalOption.name }}</p>
      <p :inner-html.prop="additionalOption.description | truncate(200)"></p>
      <div class="CartResumeAdditionalOptionCard-resume">
        <div class="CartResumeAdditionalOptionCard-price">
          <ProductPriceCart :originalPrice="additionalOption.price"></ProductPriceCart>
        </div>
        <div class="CartResumeAdditionalOptionCard-shop">
          <select
            name="quantity"
            :id="additionalOption.productId"
            ref="quantityInput"
            :value="additionalOption.quantity ? additionalOption.quantity : 1"
            @change="
              additionalOption.isInCart
                ? updateItemToCart(additionalOption.itemId, $event.target.value)
                : false
            "
          >
            <option
              :value="index + 1"
              :id="index"
              v-for="(quantity, index) in quantityChoice"
              :key="index"
              >{{ index + 1 }}</option
            >
          </select>
          <button
            v-if="additionalOption.isInCart"
            @click.prevent="removeItemToCart(additionalOption.itemId, true)"
            class="Button Button-small Button-success"
          >
            <svg
              v-svg
              symbol="Check_White"
              size="0 0 10 10"
              role="presentation"
              class="icon--inline"
            ></svg>
            Dans le panier
          </button>
          <button
            v-else
            @click.prevent="addItemToCart(additionalOption.productId, $refs.quantityInput.value)"
            class="Button Button-small Button-primary"
          >
            Ajouter au panier
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductPriceCart from "@/includes/Product/ProductPrice/ProductPriceCart.vue";
import addItemToCartMixin from "@/mixins/actions/cart/addItemToCartMixin.js";
import removeItemToCartMixin from "@/mixins/actions/cart/removeItemToCartMixin.js";
import updateItemToCartMixin from "@/mixins/actions/cart/updateItemToCartMixin.js";
import "@/includes/Cart/CartResumeAdditionalOptionCard/CartResumeAdditionalOptionCard.scss";

export default {
  name: "CartResumeAdditionalOptionCard",
  mixins: [addItemToCartMixin, removeItemToCartMixin, updateItemToCartMixin],
  components: {
    ProductPriceCart,
  },

  data() {
    return {
      quantityChoice: Array(20),
    };
  },

  props: {
    additionalOption: {
      type: Object,
      required: true,
    },
  },
};
</script>
